import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42b61990"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "StereoProjectionEditorContainer"
};
const _hoisted_2 = {
  class: "flex justify-center"
};
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center"
}, [/*#__PURE__*/_createElementVNode("span", null, "题面配置预览")], -1));
const _hoisted_5 = {
  class: "mt-2 flex justify-center gap-2"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2 flex justify-center"
}, [/*#__PURE__*/_createElementVNode("span", null, "选项预览")], -1));
const _hoisted_8 = {
  class: "flex justify-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IceCubeItem = _resolveComponent("IceCubeItem");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_LogicalTransformer2DImg = _resolveComponent("LogicalTransformer2DImg");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]), (_openBlock(), _createBlock(_component_IceCubeItem, {
    "cube-positions": $props.data.blocks,
    key: `IceCubeItem${$props.data.questionIndex}`,
    onOnSaveImage: $options.handleSaveImage,
    "view-point": null,
    subject: "StereoProjection"
  }, null, 8, ["cube-positions", "onOnSaveImage"])), _hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgs, (img, imgIdx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "flex flex-col justify-center",
      key: img
    }, [_createElementVNode("img", {
      src: img,
      style: {
        "width": "200px"
      }
    }, null, 8, _hoisted_6), _createVNode(_component_el_button, {
      type: "danger",
      class: "mt-2",
      onClick: $event => $options.deleteImg(imgIdx)
    }, {
      default: _withCtx(() => [_createTextVNode("删除")]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128))]), _hoisted_7, _createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案:" + _toDisplayString($props.data.rightAnswer), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers, (op, opIdx) => {
    return _openBlock(), _createElementBlock("div", {
      key: `op_${opIdx}`,
      class: "flex justify-center items-center flex-col"
    }, [_createVNode(_component_LogicalTransformer2DImg, {
      grid: op
    }, null, 8, ["grid"]), _createElementVNode("span", null, _toDisplayString($data.letters[opIdx]), 1)]);
  }), 128))])]);
}